<div class="layout-content-holder-bc">
    <div>
        <div id="betby-na"></div>
    </div>

</div>